import { Component, OnInit, KeyValueDiffers, DoCheck, ViewContainerRef } from '@angular/core';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Router } from "@angular/router";
import { LayoutPrintService } from "./layout-print.service";
@Component({
  selector: 'app-layout-print',
  templateUrl: './layout-print.component.html',
  styleUrls: ['./layout-print.component.css'],
  providers: [
    LayoutPrintService
  ]
})
export class LayoutPrintComponent implements OnInit {

  title: string;

  isLoading: boolean;
  filterParams: any;
  totalPage: number;
  layoutPrintList: any;
  totalElements: number;

  //watch variable change
  differ: any;

  constructor(
    private differs: KeyValueDiffers,
    private layoutPrintService: LayoutPrintService,
    private toastr: ToastsManager,
    private vcr: ViewContainerRef,
    private router: Router
  ) {
    this.toastr.setRootViewContainerRef(vcr);
    this.differ = this.differs.find({}).create();
  }

  ngOnInit() {
    this.title = "Layout Print";
    this.filterParams = {
      size: 10,
      page: 0
    };
  }

  ngDoCheck() {
    var change = this.differ.diff(this.filterParams);
    if (change) {
      if (this.filterParams.page < 0) {
        this.filterParams.page = 0;
        return;
      } else if (this.filterParams.page > this.totalPage - 1) {
        this.filterParams.page = this.totalPage - 1;
        return;
      }
      this.getLayoutPrintList();
    }
  }
  getLayoutPrintList() {

    this.isLoading = true;
    this.layoutPrintService.getLayoutPrintList(this.filterParams)
      .then(res => {
        if( res.status === 1 )
        {
          this.layoutPrintList = res.data.dataList;
          this.totalElements = res.data.totalElements;
          this.initPaginate();
        } else {
          this.toastr.error(res.message, 'Error!');
          if (res.errorCode === 3000) {
            localStorage.setItem("alert", JSON.stringify(res.message));
            this.router.navigate(['login']);
          }
        }
        this.isLoading = false;
      })
      .catch(err => console.log(err));
  }

  //init paging 
  initPaginate() {
    this.totalPage = Math.ceil(this.totalElements / this.filterParams.size);
    let arrPagingNumber = [];
    for (let i = 0; i < this.totalPage; i++) {
      arrPagingNumber.push(i);
    }
    return arrPagingNumber;
  }

  deleteLayoutPrint(layoutPrint: any) {
    if(confirm(`Confirm delete ${layoutPrint.name}?`)) {
      this.layoutPrintService.deleteLayoutPrint(layoutPrint.id)
      .then (
        res => {
          if( res.status == 1){
            this.toastr.success(res.data , 'Success!');
            this.getLayoutPrintList();
          } else {
            this.toastr.error(res.message, 'Error!');
            if (res.errorCode === 3000) {
              localStorage.setItem("alert", JSON.stringify(res.message));
              this.router.navigate(['login']);
            }
          }
        }
      ).catch(err => console.log(err))
    }
  }

}



// WEBPACK FOOTER //
// /build/client-cms/src/app/layout-print/layout-print.component.ts